import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { headerScreenOptions } from "../../components/HeaderBackButton";
import PreviewScreen from "./PreviewScreen";
import ActivityFormScreen from "./ActivityFormScreen";
import { ScreenProps, ParamList } from "./types";

const Stack = createNativeStackNavigator<ParamList>();

export default function ReportPDRScreen({ route }: ScreenProps<"ReportPDR">) {
  return (
    <Stack.Navigator screenOptions={headerScreenOptions}>
      <Stack.Screen
        name="PreviewScreen"
        component={PreviewScreen}
        options={{ title: "Report PDRs" }}
        initialParams={{ slug: route.params?.slug }}
      />
      <Stack.Screen
        name="ActivityFormScreen"
        component={ActivityFormScreen}
        options={{ title: "Report PDRs" }}
        initialParams={{ slug: route.params?.slug }}
      />
    </Stack.Navigator>
  );
}
